import _ from 'lodash';
import { ItemOf } from '@types';
import { WorkTemplateCreateData } from 'api/services/work-template/work-template-service.schema';
import { GetShiftCreateData } from 'api/services/shift/schema/get-shift-create-data.schema';

export type WorkCreateDataModel = {
  branchOfficesWithDepartments: {
    value: string;
    label: string;
    options: {
      value: string;
      label: string;
    }[];
  }[];
  breakOptions: Array<
    Pick<ItemOf<WorkTemplateCreateData['breakOptions']>, 'id' | 'label'> & {
      value: number;
    }
  >;
  jobGroups: {
    name: string;
    id: string;
    jobType: {
      name: string;
      id: string;
    }[];
  }[];
  certificates: {
    id: string;
    name: string;
  }[];
};

export const workCreateDataResponse2WorkCreateDataModel = (
  input: GetShiftCreateData
): WorkCreateDataModel => {
  const {
    shiftCreateData: { branchOfficeNames, breakOptions, jobGroups, certificates },
  } = input;

  return {
    branchOfficesWithDepartments: _.sortBy(branchOfficeNames, (branchOffice) =>
      branchOffice.name.toLowerCase()
    ).map((bo) => ({
      value: bo.id,
      label: bo.name,
      options: _.sortBy(bo.departments, (department) => department.name.toLowerCase()).map(
        (dpt) => ({
          value: dpt.id,
          label: dpt.name,
        })
      ),
    })),
    breakOptions: breakOptions.map((bo) => ({
      id: bo.id,
      label: bo.label,
      value: bo.minutes,
    })),
    jobGroups,
    certificates,
  };
};
